"use strict";
/**
 * @fileoverview API request body interface for adding a new customer
 * Defines the structure for customer creation requests
 */
Object.defineProperty(exports, "__esModule", { value: true });
